import { useMemo, useState } from "react"

import { DataFetchWrapper } from "~/components/DataFetchWrapper"
import { ProductMapping } from "~/pages/Admin/Mapping/Product/ProductMapping"
import { useFindMappingByTypeQuery } from "~/pages/Admin/Mapping/hooks/useFindMappingByTypeQuery"
import {
  DEFAULT_PAGE_SIZE,
  MappingCollapseProps,
  MappingTypeNames,
} from "~/pages/Admin/Mapping/types"

type ProductMappingWrapperProps = MappingCollapseProps

export const ProductMappingWrapper = ({
  close,
  open,
  isOpen,
}: ProductMappingWrapperProps) => {
  const [page, setPage] = useState(1)

  const [search, setSearch] = useState<string>("")

  const query = useFindMappingByTypeQuery(MappingTypeNames.PRODUCT, {
    page,
    search,
  })

  const totalPages = useMemo<number>(
    () =>
      query.data?.data.total
        ? Math.ceil(query.data.data.total / DEFAULT_PAGE_SIZE)
        : 0,
    [query.data?.data.total]
  )

  return (
    <DataFetchWrapper query={query} acceptEmpty>
      {({ data }) => (
        <ProductMapping
          productTypes={data.data.mappings}
          pagination={{
            totalPages,
            currentPage: page,
            onPageChange: setPage,
          }}
          search={search}
          setSearch={setSearch}
          isOpen={isOpen}
          close={close}
          open={open}
        />
      )}
    </DataFetchWrapper>
  )
}
